export function isAndroid() {
  if (import.meta.server) {
    return false
  }
  return /android/i.test(window.navigator.userAgent.toLowerCase())
}

export function isIOS() {
  if (import.meta.server) {
    return false
  }
  return /(iphone|ipad|ipod)/.test(window.navigator.userAgent.toLowerCase())
}

export function isWeixin() {
  if (import.meta.server) {
    return false
  }
  return /micromessenger/i.test(window.navigator.userAgent.toLowerCase())
}

export function isMobile() {
  if (import.meta.server) {
    return false
  }
  return isIOS() || isAndroid() || isWeixin()
}
